;(() => {
    const preventLoadJump = () => {
    // Keep deep links working
    if (window.location.hash) return

    // Stop browser scroll restore
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual'

    const goTop = () => window.scrollTo(0, 0)

    // Run early, then again after layout settles
    goTop()
    requestAnimationFrame(goTop)
    window.addEventListener('load', () => window.setTimeout(goTop, 0), { once: true })

    // Drop any restored focus that pulls the viewport downward
    window.setTimeout(() => {
      const ae = document.activeElement
      if (ae && ae !== document.body && typeof ae.blur === 'function') ae.blur()
    }, 0)
  }

  preventLoadJump();

  const MOBILE_MAX = 749
  const mq = window.matchMedia(`(max-width: ${MOBILE_MAX}px)`)

  const cleanupMap = (window.__lensTechScrollCleanup = window.__lensTechScrollCleanup || new Map())

  const norm = (v) => {
    const s = (v || '').toString().trim()
    if (!s) return ''
    if (s === '-') return ''
    return s
  }

  const setDisplay = (el, show) => {
    if (!el) return
    el.style.display = show ? '' : 'none'
  }

  const ensureNav = (wrap) => {
    if (!wrap) return null

    const existingPrev = wrap.querySelector('.lsNav--prev')
    const existingNext = wrap.querySelector('.lsNav--next')
    if (existingPrev && existingNext) return { prevBtn: existingPrev, nextBtn: existingNext }

    const mkBtn = (cls, label, dir) => {
      const b = document.createElement('button')
      b.type = 'button'
      b.className = `lsNav ${cls}`
      b.setAttribute('aria-label', label)
      b.dataset.dir = String(dir)
      b.hidden = true

      b.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path d="M14.5 5.5L8 12l6.5 6.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' +
        '</svg>'

      if (dir > 0) b.querySelector('path').setAttribute('d', 'M9.5 5.5L16 12l-6.5 6.5')
      return b
    }

    const prevBtn = mkBtn('lsNav--prev', 'Previous', -1)
    const nextBtn = mkBtn('lsNav--next', 'Next', 1)

    wrap.appendChild(prevBtn)
    wrap.appendChild(nextBtn)

    return { prevBtn, nextBtn }
  }

  const initSection = (section) => {
    if (!section) return

    const sectionId = section.getAttribute('data-section-id') || ''
    const prev = cleanupMap.get(sectionId)
    if (typeof prev === 'function') prev()

    const dataTag = section.querySelector('[data-ls-data]')
    let slides = []
    try {
      slides = dataTag ? JSON.parse(dataTag.textContent || '[]') : []
    } catch (e) {
      slides = []
    }
    if (!slides.length) {
      cleanupMap.set(sectionId, () => {})
      return
    }

    const stage = section.querySelector('[data-ls-stage]')
    const imgEl = section.querySelector('[data-ls-img]')
    const badgeWrap = section.querySelector('[data-ls-badge]')
    const b1 = section.querySelector('[data-ls-b1]')
    const b2 = section.querySelector('[data-ls-b2]')

    const mobileWrap = section.querySelector('[data-ls-mobile]')
    const slider = section.querySelector('[data-ls-slider]')
    const mobileSlides = slider ? Array.from(slider.querySelectorAll('[data-ls-slide]')) : []

    const desktopSteps = Array.from(section.querySelectorAll('[data-ls-step]')).map((el) => ({
      el,
      idx: Number(el.getAttribute('data-index') || '0')
    }))

    let active = -1
    let fadeTimer = null
    let imgTimer = null
    let mobObs = null
    let onMq = null
    let onScroll = null
    let onResize = null
    let navState = null

    const startFade = () => {
      if (!stage) return
      stage.classList.add('is-fading')
      window.clearTimeout(fadeTimer)
      fadeTimer = window.setTimeout(() => {
        stage.classList.remove('is-fading')
      }, 240)
    }

    const paintMedia = (idx) => {
      if (idx === active) return
      const s = slides[idx]
      if (!s) return

      active = idx
      startFade()

      const bb1 = norm(s.badge1)
      const bb2 = norm(s.badge2)

      if (b1) b1.textContent = bb1
      if (b2) b2.textContent = bb2
      setDisplay(badgeWrap, bb1.length > 0 || bb2.length > 0)

      if (imgEl && s.image) {
        window.clearTimeout(imgTimer)

        const done = () => {
          if (stage) stage.classList.remove('is-fading')
        }

        imgEl.addEventListener('load', done, { once: true })
        imgEl.src = s.image

        if (s.w && s.h) {
          imgEl.setAttribute('width', s.w)
          imgEl.setAttribute('height', s.h)
        }

        imgTimer = window.setTimeout(done, 800)
      }
    }

    const clamp01 = (x) => Math.max(0, Math.min(1, x))

    const initDesktop = () => {
      if (mq.matches) return
      if (!desktopSteps.length) return

      let raf = 0

      const update = () => {
        raf = 0
        const vh = window.innerHeight || 1
        const center = vh * 0.5
        const maxDist = vh * 0.6

        let bestIdx = 0
        let bestDist = Infinity

        for (const item of desktopSteps) {
          const r = item.el.getBoundingClientRect()
          const c = r.top + r.height * 0.5
          const dist = Math.abs(c - center)

          if (dist < bestDist) {
            bestDist = dist
            bestIdx = item.idx
          }

          const t = clamp01(dist / maxDist)
          const strength = (1 - t) * (1 - t)
          const opacity = 0.16 + strength * 0.84
          const scale = 0.98 + strength * 0.02

          item.el.style.opacity = opacity.toFixed(3)
          item.el.style.transform = `translateZ(0) scale(${scale.toFixed(3)})`
        }

        paintMedia(bestIdx)
      }

      const request = () => {
        if (raf) return
        raf = window.requestAnimationFrame(update)
      }

      onScroll = request
      onResize = request

      window.addEventListener('scroll', onScroll, { passive: true })
      window.addEventListener('resize', onResize, { passive: true })

      update()
    }

    const setActiveMobile = (idx) => {
      mobileSlides.forEach((el) => {
        const i = Number(el.getAttribute('data-index') || '0')
        el.classList.toggle('is-active', i === idx)
      })
    }

    const initMobile = () => {
      if (!mq.matches) return
      if (!slider || !mobileSlides.length) return
      // Reset horizontal position (some browsers restore scrollLeft)
      slider.scrollLeft = 0
      window.setTimeout(() => {
        slider.scrollLeft = 0
      }, 0)

      navState = ensureNav(mobileWrap)
      if (navState) {
        const { prevBtn, nextBtn } = navState

        const getGap = () => {
          const styles = window.getComputedStyle(slider)
          return parseFloat(styles.columnGap || styles.gap || '0') || 0
        }

        const getScrollAmount = () => {
          const first = slider.querySelector('[data-ls-slide]')
          if (first) return first.getBoundingClientRect().width + getGap()
          return Math.max(240, Math.floor(slider.clientWidth * 0.85))
        }

        const getPad = () => {
          const styles = window.getComputedStyle(slider)
          const pl = parseFloat(styles.paddingLeft || '0') || 0
          const pr = parseFloat(styles.paddingRight || '0') || 0
          return { pl, pr }
        }

        const setBothHidden = () => {
          prevBtn.hidden = true
          nextBtn.hidden = true
          prevBtn.disabled = true
          nextBtn.disabled = true
        }

        const updateButtons = () => {
          if (!mq.matches) {
            setBothHidden()
            return
          }

          const maxScroll = slider.scrollWidth - slider.clientWidth
          if (maxScroll <= 2) {
            setBothHidden()
            return
          }

          const pad = getPad()
          const current = slider.scrollLeft

          const startThreshold = pad.pl + 2
          const endThreshold = maxScroll - pad.pr - 2

          const atStart = current <= startThreshold
          const atEnd = current >= endThreshold

          prevBtn.disabled = atStart
          nextBtn.disabled = atEnd
          prevBtn.hidden = atStart
          nextBtn.hidden = atEnd
        }

        const scrollByDir = (dir) => {
          slider.scrollBy({ left: getScrollAmount() * dir, behavior: 'smooth' })
        }

        prevBtn.addEventListener('click', () => scrollByDir(-1))
        nextBtn.addEventListener('click', () => scrollByDir(1))

        const onMobScroll = () => updateButtons()
        const onMobResize = () => updateButtons()

        slider.addEventListener('scroll', onMobScroll, { passive: true })
        window.addEventListener('resize', onMobResize, { passive: true })

        window.setTimeout(updateButtons, 50)
        window.setTimeout(updateButtons, 300)

        cleanupMap.set(sectionId + '__mobBtns', () => {
          slider.removeEventListener('scroll', onMobScroll)
          window.removeEventListener('resize', onMobResize)
        })
      }

      if ('IntersectionObserver' in window) {
        mobObs = new IntersectionObserver(
          (entries) => {
            let best = null
            entries.forEach((e) => {
              if (!e.isIntersecting) return
              if (!best || e.intersectionRatio > best.intersectionRatio) best = e
            })
            if (!best) return
            const idx = Number(best.target.getAttribute('data-index') || '0')
            setActiveMobile(idx)
          },
          { root: slider, threshold: [0.55, 0.7, 0.85] }
        )

        mobileSlides.forEach((el) => mobObs.observe(el))
      }

      setActiveMobile(0)
    }

    paintMedia(0)
    initDesktop()
    initMobile()

    onMq = () => initSection(section)
    if (mq.addEventListener) mq.addEventListener('change', onMq)
    else mq.addListener(onMq)

    cleanupMap.set(sectionId, () => {
      window.clearTimeout(fadeTimer)
      window.clearTimeout(imgTimer)

      if (mq.removeEventListener) mq.removeEventListener('change', onMq)
      else mq.removeListener(onMq)

      if (onScroll) window.removeEventListener('scroll', onScroll)
      if (onResize) window.removeEventListener('resize', onResize)

      if (mobObs) mobObs.disconnect()

      const mobBtnsCleanup = cleanupMap.get(sectionId + '__mobBtns')
      if (typeof mobBtnsCleanup === 'function') mobBtnsCleanup()
      cleanupMap.delete(sectionId + '__mobBtns')

      for (const item of desktopSteps) {
        item.el.style.opacity = ''
        item.el.style.transform = ''
      }
    })
  }

  const initAll = () => {
    document.querySelectorAll('[data-ls-section]').forEach(initSection)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true })
  } else {
    initAll()
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target && e.target.querySelector ? e.target.querySelector('[data-ls-section]') : null
    initSection(section)
  })

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target && e.target.querySelector ? e.target.querySelector('[data-ls-section]') : null
    if (!section) return

    const sectionId = section.getAttribute('data-section-id') || ''
    const prev = cleanupMap.get(sectionId)
    if (typeof prev === 'function') prev()
    cleanupMap.delete(sectionId)
  })
})()